import React from "react";
import { ReactComponent as Question } from "../../../assets/icons/question.svg";
import { activeQuestions } from "../../../constants/zones";
import { useTranslation } from "react-i18next";
const QuestionsCard = ({
  questions = [],
  activeQuestion,
  hoverQuestion,
  data,
  setActiveQuestion,
  setHoverQuestion,
}) => {
  const { t } = useTranslation("carrier");
  return (
    <div className="zstc_col_questions">
      <div className="zstc_col_heading">{t("zoneSettings.questions")}</div>
      {questions?.map((item, questIndex) => {
        const currentData = data?.find(
          (d) => String(d.question_id) === String(item.id)
        );
        return (
          <div
            className={`zstc_col_data ${
              [activeQuestion, hoverQuestion].includes(item.id) &&
              "zstc_col_dataactive"
            } ${
              activeQuestions.includes(item.id)
                ? ""
                : "text-ui-border pointer-events-none opacity-90 select-none cursor-not-allowed"
            }`}
            style={{
              minHeight:
                item.type === "weight"
                  ? `${(currentData?.rangeData?.length || 1) * 50}px`
                  : item.type === "size"
                  ? `${(currentData?.dimensions?.length || 1) * 60 + 5}px`
                  : item.type === "cod"
                  ? `${(currentData?.cod?.length || 1) * 50 + 50}px`
                  : item.type === "protection"
                  ? `${
                      (currentData?.shipmentProtectionRange?.length || 1) * 50 +
                      50
                    }px`
                  : "50px",
              paddingBottom: ["cod", "protection"].includes(item.type)
                ? "100px"
                : item.type === "size"
                ? "0px"
                : "0px",
              marginBottom: item.type === "size" ? "50px" : "0px",
            }}
            onClick={() => setActiveQuestion(item.id)}
            onMouseEnter={() => setHoverQuestion(item.id)}
            onMouseLeave={() => setHoverQuestion(item.id)}
          >
            {item.name} <Question className="zstc_col_quest" />
          </div>
        );
      })}
    </div>
  );
};

export default QuestionsCard;
